/** Formats milliseconds as zero-padded HH:MM:SS. */
export const formatHoursMinutesSeconds = (ms: number) => {
    const pad = (value: number) => String(Math.trunc(value)).padStart(2, '0');

    return [pad(ms / (1000 * 60 * 60)), pad((ms / (1000 * 60)) % 60), pad((ms / 1000) % 60)].join(':');
};
